// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "prices__wrp-3I3yV";
var _4 = "selectFrom_best-1BLQe";
var _5 = "fare_family-sgFTz";
var _6 = "subsidies-33jpV";
var _7 = "price_subsidies-1AJhn";
var _8 = "infoMessage-ArbSw";
var _9 = "infoMessage__htmlMessage-2UI5O";
var _a = "clear-3W7OJ";
var _b = "price-238cm";
var _c = "price_selected-3Koy0";
var _d = "price_original-16j4a";
var _e = "price__container-1UN2g";
var _f = "price__money-2aUrq";
var _10 = "price__money_tooBig-1MQDM";
var _11 = "price__money_withPromoCode-ii1rn";
var _12 = "price_miles-1Dubo";
var _13 = "currency-2nxmg";
var _14 = "miles__taxes-3ZsZC";
var _15 = "seats-21__K";
var _16 = "best-35IQm";
var _17 = "button-2mYvV";
var _18 = "canceled-1IKMj";
var _19 = "subsidies__tooltip-2vwVq";
var _1a = "taxes__childrenWrapper-2556g";
export { _1 as "__esModule", _2 as "tablet", _3 as "prices__wrp", _4 as "selectFrom_best", _5 as "fare_family", _6 as "subsidies", _7 as "price_subsidies", _8 as "infoMessage", _9 as "infoMessage__htmlMessage", _a as "clear", _b as "price", _c as "price_selected", _d as "price_original", _e as "price__container", _f as "price__money", _10 as "price__money_tooBig", _11 as "price__money_withPromoCode", _12 as "price_miles", _13 as "currency", _14 as "miles__taxes", _15 as "seats", _16 as "best", _17 as "button", _18 as "canceled", _19 as "subsidies__tooltip", _1a as "taxes__childrenWrapper" }
export default { "__esModule": _1, "tablet": _2, "prices__wrp": _3, "selectFrom_best": _4, "fare_family": _5, "subsidies": _6, "price_subsidies": _7, "infoMessage": _8, "infoMessage__htmlMessage": _9, "clear": _a, "price": _b, "price_selected": _c, "price_original": _d, "price__container": _e, "price__money": _f, "price__money_tooBig": _10, "price__money_withPromoCode": _11, "price_miles": _12, "currency": _13, "miles__taxes": _14, "seats": _15, "best": _16, "button": _17, "canceled": _18, "subsidies__tooltip": _19, "taxes__childrenWrapper": _1a }
